import React from 'react';

// eslint-disable-next-line react/require-default-props
export default function AngleDown({ className = undefined }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 12 8"
    >
      <path d="M5.53516 7.21484L0.285156 1.96484C0.0117188 1.71875 0.0117188 1.30859 0.285156 1.03516C0.53125 0.789062 0.941406 0.789062 1.21484 1.03516L6 5.84766L10.7852 1.0625C11.0312 0.789062 11.4414 0.789062 11.7148 1.0625C11.9609 1.30859 11.9609 1.71875 11.7148 1.96484L6.4375 7.21484C6.19141 7.48828 5.78125 7.48828 5.53516 7.21484Z" />
    </svg>
  );
}
